<template>
  <div
    class="max-h-full max-w-full overflow-hidden h-screen absolute w-screen -z-10"
  >
    <Vue3Lottie
      :animation-data="bubble"
      :speed="0.2"
      class="bubble_left max-h-full max-w-full absolute fixed w-[200%] lg:w-[150%] -left-[25%] lg:-top-[50%] max-h-[200%] -z-10"
    />

    <Vue3Lottie
      :animation-data="bubble"
      :speed="0.6"
      class="bubble_right max-h-full max-w-full absolute fixed lg:w-[100%] w-[150%] -right-[50%] lg:-right-[50%] max-w-[200%] fill-bkk-60 -z-10"
    />
  </div>
</template>

<script>
import { Vue3Lottie } from "vue3-lottie";
import bubble from "../../../animations/bubbles/assessment-bubbles.json";

export default {
  name: "BackgroundBubbles",
  components: {
    Vue3Lottie,
  },
  data() {
    return {
      bubble,
    };
  },
};
</script>
